import { UploadTaskRequestTypeEnum } from "@nens/brostar/openapi-client";
import {
  CorrectionReasonOptions,
  GldAirPressureCompensationTypeOptions,
  GldEvaluationProcedureOptions,
  GldMeasurementInstrumentOptions,
  GldObservationTypeOptions,
  GldProcessReferenceOptions,
  GldStatusQualityControlOptions,
  QualityRegimeOptions,
  correctionReasonOptions,
  gldAirPressureCompensationTypeOptions,
  gldEvaluationProcedureOptions,
  gldMeasurementInstrumentOptions,
  gldObservationTypeOptions,
  gldProcessReferenceOptions,
  gldStatusQualityControlOptions,
  qualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

const GLD_FIELD_SCHEMA_LIBRARY = {
  // Shared metadata fields
  projectNumber: addSchema<string>({ type: "string", title: "Projectnummer" }),
  broId: addSchema<string>({ type: "string", title: "BRO-ID Tijdreeksdossier" }),
  qualityRegime: addSchema<QualityRegimeOptions>({
    type: "string",
    title: "Kwaliteitsregime",
    enum: qualityRegimeOptions.map((opt) => opt.value),
  }),
  deliveryAccountableParty: addSchema<string>({
    type: "string",
    title: "Bronhouder [KVK]",
  }),
  correctionReason: addSchema<CorrectionReasonOptions>({
    type: "string",
    title: "Correctie reden",
    enum: correctionReasonOptions.map((opt) => opt.value),
  }),

  // GLD Start Registration fields
  objectIdAccountableParty: addSchema<string>({ type: "string", title: "Interne naam" }),
  gmwBroId: addSchema<string>({ type: "string", title: "BRO-ID Put" }),
  tubeNumber: addSchema<string>({ type: "string", title: "Buisnummer" }),
  groundwaterMonitoringNets: addSchema<string[]>({
    type: "array",
    title: "Grondwatermeetnetten",
    items: { type: "string" },
  }),

  // GLD Addition fields
  observationId: addSchema<string | undefined>({
    type: "string",
    title: "Observatie ID",
    readOnly: true,
  }),
  processReference: addSchema<GldProcessReferenceOptions>({
    type: "string",
    title: "Meetprocedure",
    enum: gldProcessReferenceOptions.map((opt) => opt.value),
  }),
  evaluationProcedure: addSchema<GldEvaluationProcedureOptions>({
    type: "string",
    title: "Evaluatieprocedure",
    enum: gldEvaluationProcedureOptions.map((opt) => opt.value),
  }),
  measurementInstrumentType: addSchema<GldMeasurementInstrumentOptions>({
    type: "string",
    title: "Type meetinstrument",
    enum: gldMeasurementInstrumentOptions.map((opt) => opt.value),
  }),
  airPressureCompensationType: addSchema<GldAirPressureCompensationTypeOptions>({
    type: "string",
    title: "Type luchtdrukcompensatie",
    enum: gldAirPressureCompensationTypeOptions.map((opt) => opt.value),
  }),
  investigatorKvk: addSchema<string>({ type: "string", title: "Uitvoerder [KVK]" }),
  observationType: addSchema<GldObservationTypeOptions>({
    type: "string",
    title: "Metingtype",
    enum: gldObservationTypeOptions.map((opt) => opt.value),
  }),
  statusQualityControl: addSchema<GldStatusQualityControlOptions>({
    type: "string",
    title: "Validatiestatus",
    enum: gldStatusQualityControlOptions.map((opt) => opt.value),
  }),
  timeseriesFile: addSchema<Blob>({
    type: "string",
    format: "data-url",
    title: "Tijdseries bestand (CSV/Excel)",
  }),

  requestType: addSchema<UploadTaskRequestTypeEnum>({
    type: "string",
    title: "Request Type",
    enum: Object.values(UploadTaskRequestTypeEnum),
  }),
};

type FieldSchemaLibraryType = typeof GLD_FIELD_SCHEMA_LIBRARY;

export function pickGldLibraryFields<K extends keyof FieldSchemaLibraryType>(
  fieldNames: readonly K[]
): Pick<FieldSchemaLibraryType, K> {
  const result = {} as Pick<FieldSchemaLibraryType, K>;
  for (const name of fieldNames) {
    result[name] = GLD_FIELD_SCHEMA_LIBRARY[name];
  }
  return result;
}
